module.exports = __webpack_public_path__ + "static/tradee_title-e683d6c0d68e8b59c3b301b417e23e0c.png";